import { ref, computed, getCurrentScope, onScopeDispose, markRaw } from "vue";
const LOADING_TEXT = "Loading...";
const show = ref(false);
const loadingItems = ref([]);
const content = computed(() => {
  var _a;
  return (_a = loadingItems.value[loadingItems.value.length - 1]) == null ? void 0 : _a.content;
});
const props = computed(() => {
  var _a;
  return (_a = loadingItems.value[loadingItems.value.length - 1]) == null ? void 0 : _a.props;
});
const usePLoading = (options) => {
  const { delay } = { delay: 200, ...options };
  const scope = getCurrentScope();
  const clearLoadingItems = () => {
    loadingItems.value.forEach((item) => {
      clearTimeout(item.timer);
    });
    loadingItems.value = [];
  };
  const loadingShow = (loadingItem) => {
    let timer = 0;
    if (!loadingItem.id) {
      throw new Error("id is required");
    }
    if (loadingItems.value.length === 0 && delay > 0) {
      timer = setTimeout(() => {
        show.value = true;
      }, delay);
    } else {
      show.value = true;
    }
    loadingItems.value.push({
      id: loadingItem.id,
      content: loadingItem.content && typeof loadingItem.content === "object" ? markRaw(loadingItem.content) : loadingItem.content || LOADING_TEXT,
      props: loadingItem.props,
      timer,
      clearOnDispose: loadingItem.clearOnDispose ?? true
    });
  };
  const loadingHide = (id) => {
    if (id && typeof id === "string") {
      const index = loadingItems.value.findIndex((item) => item.id === id);
      const loadingItem = loadingItems.value[index];
      if (index !== -1) {
        clearTimeout(loadingItem.timer);
        loadingItems.value.splice(index, 1);
      }
    } else {
      clearLoadingItems();
    }
    if (loadingItems.value.length === 0) {
      show.value = false;
    }
  };
  const isLoading = (id) => {
    if (id) {
      return loadingItems.value.some((item) => item.id === id);
    }
    return loadingItems.value.length > 0;
  };
  if (scope) {
    onScopeDispose(() => {
      if (loadingItems.value.some((item) => item.clearOnDispose === false)) {
        loadingItems.value.forEach((item) => {
          if (item.clearOnDispose) {
            clearTimeout(item.timer);
          }
        });
        loadingItems.value = loadingItems.value.filter((item) => item.clearOnDispose === false);
      } else {
        clearLoadingItems();
        show.value = false;
      }
    });
  }
  return { show, content, props, loadingShow, loadingHide, isLoading };
};
export {
  usePLoading
};
